import Datepicker from "common/Datepicker/Datepicker";
import InfoPopup from "common/InfoPopup/InfoPopup";
import InputField from "common/InputField/InputField";
import NavigationButtons from "common/NavigationButtons/NavigationButtons";
import RadioButton from "common/Radio/RadioButton";
import SelectDropdown from "common/SelectDropdown/SelectDropdown";
import { useContext } from "react";
import Button from "common/Button/Button";
import Checkbox from "common/Checkbox/Checkbox";

const ProvideInformation = ({ context }) => {
  const {
    labels,
    navigateToStep3,
    sanitize,
    payload,
    updatePayload,
    cancel,
    participantAge,
    nextDisabled,
    getPayoutRate,
    errorProps,
    onChange,
    addressSameAsOwner,
    checkUSStateSelected,
    getStateCountryData,
    participantDetails,
  } = useContext(context);

  const electionChoice = {
    name: "electionChoice",
    header: labels?.incomeElection?.title,
    subHeader: labels?.incomeElection?.benefitOptionHeader,
    data: [
      {
        label: labels?.incomeElection?.single,
        id: "S",
        ariaLabel: "Single Life",
        disabled: false,
        displayChildren: true,
        children: (
          <InfoPopup
            position="top"
            content={labels?.incomeElection?.singlePopupMsg}
          />
        ),
      },
      {
        label: labels?.incomeElection?.joint,
        id: "J",
        ariaLabel: "Joint Life",
        disabled:
          ["S", "D", "W"].indexOf(participantDetails.maritalStatusCode) > -1,
        displayChildren: true,
        children: (
          <InfoPopup
            position="top"
            content={labels?.incomeElection?.jointPopupMsg}
          />
        ),
      },
    ],
  };

  const genderOptions = {
    name: "gender",
    header: labels?.incomeElection?.genderMandatory,
    data: [
      {
        label: labels?.incomeElection?.male,
        id: "M",
        ariaLabel: "male",
      },
      {
        label: labels?.incomeElection?.female,
        id: "F",
        ariaLabel: "female",
      },
    ],
  };

  return (
    <section className="section-one mb-3">
      {payload.maritalStatusConfirm === "N" ? (
        <div
          dangerouslySetInnerHTML={sanitize(
            labels?.incomeElection?.maritalStatusNoMsg
          )}
        ></div>
      ) : (
        <>
          <section className="mb-4">
            <div className="mb-1 fw-bold">
              {labels?.incomeElection?.payoutRates}
              <InfoPopup
                position="top"
                content={labels?.incomeElection?.payoutRatesPopupMsg}
              />
            </div>
            <p>
              {["S", "D", "W"].indexOf(participantDetails.maritalStatusCode) >
              -1
                ? labels?.incomeElection?.payoutRatesInfoMsgSingle
                : labels?.incomeElection?.payoutRatesInfoMsgJoint}
            </p>
            <div className="d-flex flex-wrap justify-content-between">
              <div className="col-12 col-md-4 p-4 payoutRatesBox mb-3">
                <h5 className="mb-3">{labels?.incomeElection?.single}</h5>
                <div className="d-flex justify-content-between border-bottom-1-dark pb-2 mb-2">
                  <div className="col-8 text-center">
                    {labels?.incomeElection?.yourAge}
                  </div>
                  <div className="col-4 text-center">
                    {labels?.incomeElection?.payoutRate}
                  </div>
                </div>

                <div className="d-flex justify-content-between">
                  <div className="col-8 text-center">{participantAge}+</div>
                  <div className="col-4 text-center">
                    {getPayoutRate("single")}
                  </div>
                </div>
              </div>

              {["M", "O", "U"].indexOf(participantDetails.maritalStatusCode) >
                -1 && (
                <div className="col-12 col-md-7 p-4 payoutRatesBox">
                  <h5 className="mb-3">{labels?.incomeElection?.joint}</h5>
                  <div className="d-flex justify-content-between border-bottom-1-dark pb-2 mb-2">
                    <div className="col-4 text-center">
                      {labels?.incomeElection?.yourAge}
                    </div>
                    <div className="col-5 text-center">
                      {labels?.incomeElection?.ageOfSpouse}
                    </div>
                    <div className="col-3 text-center">
                      {labels?.incomeElection?.payoutRate}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between border-bottom-1 pb-2 mb-2">
                    <div className="col-4 text-center">{participantAge}+</div>
                    <div className="col-5 text-center">
                      {participantAge - 10}+
                    </div>
                    <div className="col-3 text-center">
                      {getPayoutRate("joint", participantAge - 10)}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between border-bottom-1 pb-2 mb-2">
                    <div className="col-4 text-center">{participantAge}+</div>
                    <div className="col-5 text-center">
                      {participantAge - 15}-{participantAge - 11}
                    </div>
                    <div className="col-3 text-center">
                      {getPayoutRate("joint", participantAge - 15)}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between border-bottom-1 pb-2 mb-2">
                    <div className="col-4 text-center">{participantAge}+</div>
                    <div className="col-5 text-center">
                      {participantAge - 20}-{participantAge - 16}
                    </div>
                    <div className="col-3 text-center">
                      {getPayoutRate("joint", participantAge - 20)}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="col-4 text-center">{participantAge}+</div>
                    <div className="col-5 text-center">
                      &lt;{participantAge - 20}
                    </div>
                    <div className="col-3 text-center">
                      {getPayoutRate("joint", participantAge - 20)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
          <RadioButton
            data={electionChoice}
            wrapperClassName="mb-3"
            radioClassName="d-flex mt-4"
            value={payload?.electionChoice}
            selected={(e) => updatePayload(e, "electionChoice")}
          />
          {participantDetails?.maritalStatusCode === "M" &&
            payload.electionChoice === "S" && (
              <div className="border-1 p-3">
                {labels?.incomeElection?.singleMsg}
              </div>
            )}

          {payload.electionChoice === "J" && (
            <>
              <div className="d-flex flex-wrap">
                <InputField
                  label={labels?.incomeElection?.jointSSN}
                  type="number"
                  wrapperClassName="col-12 col-md-5 col-xl-4 mb-3"
                  id="annuitantTaxId"
                  ariaLabel="Joint Life SSN"
                  {...errorProps("annuitantTaxId")}
                  change={(val) => onChange(val, "annuitantTaxId")}
                />

                <Datepicker
                  wrapperClassName="col-12 col-md-5 col-xl-4 px-2 mb-3"
                  label={labels?.incomeElection?.dobMandatory}
                  value={payload?.annuitantBirthDate}
                  blur={(val) => updatePayload(val, "annuitantBirthDate")}
                  ariaLabel="DOB"
                />
              </div>

              {/* Name  */}
              <div className="d-flex flex-wrap">
                <InputField
                  label={labels?.incomeElection?.jointFName}
                  type="text"
                  wrapperClassName="col-12 col-md-4 mb-3"
                  id="annuitantFirstName"
                  ariaLabel="First Name"
                  {...errorProps("annuitantFirstName")}
                  change={(val) => onChange(val, "annuitantFirstName")}
                />
                <InputField
                  label={labels?.incomeElection?.jointMName}
                  type="text"
                  wrapperClassName="col-12 col-md-4 px-2 mb-3"
                  id="annuitantMiddleName"
                  ariaLabel="Middle Name"
                  value={payload?.annuitantMiddleName}
                  blur={(val) => updatePayload(val, "annuitantMiddleName")}
                />
                <InputField
                  label={labels?.incomeElection?.jointLName}
                  type="text"
                  wrapperClassName="col-12 col-md-4 mb-3"
                  id="annuitantLastName"
                  ariaLabel="Last Name"
                  {...errorProps("annuitantLastName")}
                  change={(val) => onChange(val, "annuitantLastName")}
                />
              </div>

              <div className="d-flex mb-3">
                <RadioButton
                  data={genderOptions}
                  radioClassName="d-flex mt-2"
                  value={payload?.annuitantGenderCode}
                  selected={(e) => updatePayload(e, "annuitantGenderCode")}
                />
                <Checkbox
                  id="civilUnionCode"
                  label={labels?.incomeElection?.civilUnion}
                  change={(val) => updatePayload(val, "civilUnionCode")}
                  ariaLabel="civilUnionCode"
                />
              </div>

              <Button
                wrapperClassName="col-md-3 mb-3"
                type="primary"
                text="Address Same As Owner"
                click={addressSameAsOwner}
                ariaLabel="Address Same As Owner"
              />

              {/* Address  */}
              <>
                <InputField
                  label={labels?.incomeElection?.annuitantAddressLine1}
                  type="text"
                  wrapperClassName="mb-3"
                  id="annuitantAddressLine1"
                  ariaLabel="Address Line One"
                  {...errorProps("annuitantAddressLine1")}
                  change={(val) => onChange(val, "annuitantAddressLine1")}
                />

                <InputField
                  label={labels?.incomeElection?.annuitantAddressLine2}
                  type="text"
                  wrapperClassName="col-12 mb-3"
                  id="annuitantAddressLine2"
                  ariaLabel="Address Line Two"
                  value={payload?.annuitantAddressLine2}
                  blur={(val) => updatePayload(val, "annuitantAddressLine2")}
                />

                <InputField
                  label={labels?.incomeElection?.annuitantAddressLine3}
                  type="text"
                  wrapperClassName="col-12 mb-3"
                  id="annuitantAddressLine3"
                  ariaLabel="Address Line Two"
                  value={payload?.annuitantAddressLine3}
                  blur={(val) => updatePayload(val, "annuitantAddressLine3")}
                />
              </>

              {/* City, Country & Zip  */}
              <div className="d-flex flex-wrap">
                <InputField
                  label={labels?.incomeElection?.cityMandatory}
                  type="text"
                  wrapperClassName="col-12 col-md-5 mb-3"
                  id="annuitantCity"
                  ariaLabel="City"
                  {...errorProps("annuitantCity")}
                  change={(val) => onChange(val, "annuitantCity")}
                />
                <SelectDropdown
                  label={labels?.incomeElection?.stateCountry}
                  wrapperClassName="col-12 col-md-4 mb-3 px-2"
                  selectClassName="w-100"
                  dropdownData={getStateCountryData()}
                  value={payload.annuitantState}
                  select={(e) => updatePayload(e, "annuitantState")}
                  optionId="value"
                  optionLabel="label"
                  ariaLabel="State Dropdown"
                  defaultOption={true}
                />
                {checkUSStateSelected() ? (
                  <InputField
                    label={labels?.incomeElection?.zipCode + " *"}
                    type="text"
                    wrapperClassName="col-12 col-md-3 mb-3"
                    id="annuitantZipCode"
                    ariaLabel="Zip Code"
                    {...errorProps("annuitantZipCode")}
                    change={(val) => onChange(val, "annuitantZipCode")}
                  />
                ) : (
                  <InputField
                    label={labels?.incomeElection?.zipCode}
                    type="text"
                    wrapperClassName="col-12 col-md-3 mb-3"
                    id="annuitantZipCode"
                    ariaLabel="Zip Code"
                    value={payload?.annuitantZipCode}
                    change={(val) => updatePayload(val, "annuitantZipCode")}
                  />
                )}
              </div>

              <div className="d-flex flex-wrap">
                <InputField
                  label={labels?.incomeElection?.emailMandatory}
                  type="text"
                  wrapperClassName="col-12 col-md-7 mb-3"
                  id="annuitantEmailAddress"
                  ariaLabel="Email"
                  {...errorProps("annuitantEmailAddress")}
                  change={(val) => onChange(val, "annuitantEmailAddress")}
                />
                <InputField
                  label={labels?.incomeElection?.phoneMandatory}
                  type="number"
                  wrapperClassName="col-12 col-md-5 mb-3 ps-2"
                  id="annuitantPhoneNumber"
                  ariaLabel="Phone Number"
                  {...errorProps("annuitantPhoneNumber")}
                  change={(val) => onChange(val, "annuitantPhoneNumber")}
                />
              </div>
            </>
          )}
        </>
      )}

      <NavigationButtons
        wrapperClassName="mt-5 pt-5 border-top-1"
        leftLabel={labels?.incomeElection?.back}
        leftClick={cancel}
        rightLabel={
          payload.maritalStatusConfirm === "Y" && labels?.incomeElection?.next
        }
        rightClick={navigateToStep3}
        rightDisabled={nextDisabled}
      />
    </section>
  );
};

export default ProvideInformation;
